import { render, staticRenderFns } from "./Amortize.vue?vue&type=template&id=a7061af4&scoped=true&"
import script from "./Amortize.vue?vue&type=script&lang=js&"
export * from "./Amortize.vue?vue&type=script&lang=js&"
import style0 from "./Amortize.vue?vue&type=style&index=0&id=a7061af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7061af4",
  null
  
)

export default component.exports